import { baseApi } from './baseApi';

export const emailTemplateApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getEmailTemplates: builder.query({
      query: () => '/email-templates',
      providesTags: ['EmailTemplate'],
    }),
    getEmailTemplateById: builder.query({
      query: (id) => `/email-templates/${id}`,
      providesTags: (result, error, id) => [{ type: 'EmailTemplate', id }],
    }),
    createEmailTemplate: builder.mutation({
      query: (data) => ({
        url: '/email-templates',
        method: 'POST',
        body: data,
      }),
      invalidatesTags: ['EmailTemplate'],
    }),
    updateEmailTemplate: builder.mutation({
      query: ({ id, ...data }) => ({
        url: `/email-templates/${id}`,
        method: 'PUT',
        body: data,
      }),
      invalidatesTags: (result, error, { id }) => [{ type: 'EmailTemplate', id }, 'EmailTemplate'],
    }),
    deleteEmailTemplate: builder.mutation({
      query: (id) => ({
        url: `/email-templates/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['EmailTemplate'],
    }),
  }),
});

export const {
  useGetEmailTemplatesQuery,
  useGetEmailTemplateByIdQuery,
  useCreateEmailTemplateMutation,
  useUpdateEmailTemplateMutation,
  useDeleteEmailTemplateMutation,
} = emailTemplateApi;
